module.exports = __webpack_public_path__ + "img/train-4.9167d11f.jpg";